"use strict";

var _get = require("C:\\Users\\Gralath\\Documents\\VECHAIN\\voting-app\\node_modules\\@babel\\runtime/helpers/get");

var _possibleConstructorReturn = require("C:\\Users\\Gralath\\Documents\\VECHAIN\\voting-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\Gralath\\Documents\\VECHAIN\\voting-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\Gralath\\Documents\\VECHAIN\\voting-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _classCallCheck = require("C:\\Users\\Gralath\\Documents\\VECHAIN\\voting-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\Gralath\\Documents\\VECHAIN\\voting-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bignumber_js_1 = require("bignumber.js");

var rlp = require('rlp');

var RLP =
/*#__PURE__*/
function () {
  function RLP(profile) {
    _classCallCheck(this, RLP);

    this.profile = profile;
  }
  /**
   * encode data according to profile
   * @param data the structured data to be encoded
   */


  _createClass(RLP, [{
    key: "encode",
    value: function encode(data) {
      var packed = pack(data, this.profile, '');
      return rlp.encode(packed);
    }
    /**
     * decode buffer according to profile
     * @param buf rlp encoded data
     */

  }, {
    key: "decode",
    value: function decode(buf) {
      var packed = rlp.decode(buf);
      return unpack(packed, this.profile, '');
    }
  }]);

  return RLP;
}();

exports.RLP = RLP;

(function (RLP) {
  /** base class of scalar kind */
  var ScalarKind = function ScalarKind() {
    _classCallCheck(this, ScalarKind);
  };

  RLP.ScalarKind = ScalarKind;
  /** a noop scalar kind */

  var RawKind =
  /*#__PURE__*/
  function (_ScalarKind) {
    _inherits(RawKind, _ScalarKind);

    function RawKind() {
      _classCallCheck(this, RawKind);

      return _possibleConstructorReturn(this, _getPrototypeOf(RawKind).call(this));
    }

    _createClass(RawKind, [{
      key: "encode",
      value: function encode(data, ctx) {
        return data;
      }
    }, {
      key: "decode",
      value: function decode(buf, ctx) {
        return buf;
      }
    }]);

    return RawKind;
  }(ScalarKind);

  RLP.RawKind = RawKind;
  /** a scalar kind to presents number */

  var NumericKind =
  /*#__PURE__*/
  function (_ScalarKind2) {
    _inherits(NumericKind, _ScalarKind2);

    /**
     * create a numeric kind
     * @param maxBytes up limit of data in bytes
     */
    function NumericKind(maxBytes) {
      var _this;

      _classCallCheck(this, NumericKind);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(NumericKind).call(this));
      _this.maxBytes = maxBytes;
      return _this;
    }

    _createClass(NumericKind, [{
      key: "encode",
      value: function encode(data, ctx) {
        assert(typeof data === 'string' || typeof data === 'number', ctx, 'expected string or number');

        if (typeof data === 'string') {
          var isHex = isHexString(data);
          var isDec = isDecString(data);
          assert(isHex || isDec, ctx, 'expected non-negative integer in hex or dec string');

          if (isHex) {
            assert(data.length > 2, ctx, 'expected valid hex string');
          }
        } else {
          assert(Number.isSafeInteger(data) && data >= 0, ctx, 'expected non-negative safe integer');
        }

        var bn = new bignumber_js_1.BigNumber(data);

        if (bn.isZero()) {
          return Buffer.alloc(0);
        }

        var hex = bn.toString(16);

        if (hex.length % 2 !== 0) {
          hex = '0' + hex;
        }

        var buf = Buffer.from(hex, 'hex');
        assert(this.maxBytes ? buf.length <= this.maxBytes : true, ctx, "expected number in ".concat(this.maxBytes, " bytes"));
        return buf;
      }
    }, {
      key: "decode",
      value: function decode(buf, ctx) {
        assert(this.maxBytes ? buf.length <= this.maxBytes : true, ctx, "expected less than ".concat(this.maxBytes, " bytes"));

        if (buf.length === 0) {
          return 0;
        }

        assert(buf[0] !== 0, ctx, "expected canonical integer (no leading zero bytes)");
        var bn = new bignumber_js_1.BigNumber(buf.toString('hex'), 16);
        var num = bn.toNumber();
        return Number.isSafeInteger(num) ? num : '0x' + bn.toString(16);
      }
    }]);

    return NumericKind;
  }(ScalarKind);

  RLP.NumericKind = NumericKind;
  /** a scalar kind to present fixed length blob */

  var BlobKind =
  /*#__PURE__*/
  function (_ScalarKind3) {
    _inherits(BlobKind, _ScalarKind3);

    /**
     * create blob kind
     * @param bytes size of blob in bytes
     */
    function BlobKind(bytes) {
      var _this2;

      _classCallCheck(this, BlobKind);

      _this2 = _possibleConstructorReturn(this, _getPrototypeOf(BlobKind).call(this));
      _this2.bytes = bytes;
      return _this2;
    }

    _createClass(BlobKind, [{
      key: "encode",
      value: function encode(data, ctx) {
        assert(isHexString(data), ctx, 'expected hex string');
        assert(data.length === this.bytes * 2 + 2, ctx, "expected hex string presents ".concat(this.bytes, " bytes"));
        return Buffer.from(data.slice(2), 'hex');
      }
    }, {
      key: "decode",
      value: function decode(buf, ctx) {
        assert(buf.length === this.bytes, ctx, "expected ".concat(this.bytes, " bytes"));
        return '0x' + buf.toString('hex');
      }
    }]);

    return BlobKind;
  }(ScalarKind);

  RLP.BlobKind = BlobKind;
  /** blob kind that can be null */

  var NullableBlobKind =
  /*#__PURE__*/
  function (_BlobKind) {
    _inherits(NullableBlobKind, _BlobKind);

    function NullableBlobKind() {
      _classCallCheck(this, NullableBlobKind);

      return _possibleConstructorReturn(this, _getPrototypeOf(NullableBlobKind).apply(this, arguments));
    }

    _createClass(NullableBlobKind, [{
      key: "encode",
      value: function encode(data, ctx) {
        if (data) {
          return _get(_getPrototypeOf(NullableBlobKind.prototype), "encode", this).call(this, data, ctx);
        }

        return Buffer.alloc(0);
      }
    }, {
      key: "decode",
      value: function decode(buf, ctx) {
        if (buf.length === 0) {
          return null;
        }

        return _get(_getPrototypeOf(NullableBlobKind.prototype), "decode", this).call(this, buf, ctx);
      }
    }]);

    return NullableBlobKind;
  }(BlobKind);

  RLP.NullableBlobKind = NullableBlobKind;
  /** a blob kind that leading zero will be removed when encoded */

  var TrimmedBlobKind =
  /*#__PURE__*/
  function (_BlobKind2) {
    _inherits(TrimmedBlobKind, _BlobKind2);

    function TrimmedBlobKind() {
      _classCallCheck(this, TrimmedBlobKind);

      return _possibleConstructorReturn(this, _getPrototypeOf(TrimmedBlobKind).apply(this, arguments));
    }

    _createClass(TrimmedBlobKind, [{
      key: "encode",
      value: function encode(data, ctx) {
        var buf = _get(_getPrototypeOf(TrimmedBlobKind.prototype), "encode", this).call(this, data, ctx);

        var nzIndex = buf.findIndex(function (v) {
          return v !== 0;
        });

        if (nzIndex >= 0) {
          return buf.slice(nzIndex);
        }

        return Buffer.alloc(0);
      }
    }, {
      key: "decode",
      value: function decode(buf, ctx) {
        assert(buf.length <= this.bytes, ctx, "expected less than ".concat(this.bytes, " bytes"));
        var zeros = '0'.repeat((this.bytes - buf.length) * 2);
        return '0x' + zeros + buf.toString('hex');
      }
    }]);

    return TrimmedBlobKind;
  }(BlobKind);

  RLP.TrimmedBlobKind = TrimmedBlobKind;
  /** a blob kind with variable length */

  var VariableBlobKind =
  /*#__PURE__*/
  function (_BlobKind3) {
    _inherits(VariableBlobKind, _BlobKind3);

    function VariableBlobKind(maxBytes) {
      var _this3;

      _classCallCheck(this, VariableBlobKind);

      if (maxBytes) {
        _this3 = _possibleConstructorReturn(this, _getPrototypeOf(VariableBlobKind).call(this, maxBytes));
      } else {
        _this3 = _possibleConstructorReturn(this, _getPrototypeOf(VariableBlobKind).call(this, Number.MAX_SAFE_INTEGER));
      }

      return _possibleConstructorReturn(_this3);
    }

    _createClass(VariableBlobKind, [{
      key: "encode",
      value: function encode(data, ctx) {
        assert(isHexString(data), ctx, 'expected hex string');
        assert(data.length % 2 === 0, ctx, 'expected even length hex');
        var buf = Buffer.from(data.slice(2), 'hex');
        assert(buf.length <= this.bytes, ctx, "expected less than ".concat(this.bytes, " bytes"));
        return buf;
      }
    }, {
      key: "decode",
      value: function decode(buf, ctx) {
        assert(buf.length <= this.bytes, ctx, "expected less than ".concat(this.bytes, " bytes"));
        return '0x' + buf.toString('hex');
      }
    }]);

    return VariableBlobKind;
  }(BlobKind);

  RLP.VariableBlobKind = VariableBlobKind;
})(RLP = exports.RLP || (exports.RLP = {}));

function pack(obj, profile, ctx) {
  ctx = ctx ? ctx + '.' + profile.name : profile.name;
  var kind = profile.kind;

  if (kind instanceof RLP.ScalarKind) {
    return kind.encode(obj, ctx);
  }

  if (Array.isArray(kind)) {
    return kind.map(function (k) {
      return pack(obj[k.name], k, ctx);
    });
  }

  assert(Array.isArray(obj), ctx, 'expected array');
  var item = kind.item;
  return obj.map(function (part, i) {
    return pack(part, {
      name: '#' + i,
      kind: item
    }, ctx);
  });
}

function unpack(packed, profile, ctx) {
  ctx = ctx ? ctx + '.' + profile.name : profile.name;
  var kind = profile.kind;

  if (kind instanceof RLP.ScalarKind) {
    if (!(kind instanceof RLP.RawKind)) {
      assert(Buffer.isBuffer(packed), ctx, 'expected Buffer');
    }

    return kind.decode(packed, ctx);
  }

  if (Array.isArray(kind)) {
    assert(Array.isArray(packed), ctx, 'expected array');
    var parts = packed;
    assert(parts.length === kind.length, ctx, "expected ".concat(kind.length, " items, but got ").concat(parts.length));
    return kind.reduce(function (o, p, i) {
      o[p.name] = unpack(parts[i], p, ctx);
      return o;
    }, {});
  }

  assert(Array.isArray(packed), ctx, 'expected array');
  var item = kind.item;
  return packed.map(function (part, i) {
    return unpack(part, {
      name: '#' + i,
      kind: item
    }, ctx);
  });
}

function assert(cond, ctx, msg) {
  if (!cond) {
    throw new Error("".concat(ctx, ": ").concat(msg));
  }
}

function isHexString(str) {
  return /^0x[0-9a-f]*$/i.test(str);
}

function isDecString(str) {
  return /^[0-9]+$/.test(str);
}